import React, { useContext, useEffect, useState } from "react";

//access url string
import qs from "query-string";

//access browser history
import { useHistory } from "react-router-dom";

// Styling
import "../../../node_modules/graphiql/graphiql.css";
import "./Module.css";

//components
import WeaviateErrorPage from "../../components/console/WeaviateErrorPage";
import ModuleContent from "./ModuleContent";

// global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

// helper functions
import { decisionMaker } from "./helpers";

const Module = () => {
  // global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  // Control the confirmation modal
  const [isURICheckerModalOpen, setIsURICheckerModalOpen] = useState(false);

  // To use history
  const history = useHistory();

  // Access the url if there is any param
  const hashObj = qs.parse(window.location.hash);

  useEffect(() => {
    // This function decides how this module behaves every time it's rendered
    decisionMaker(state, setState, hashObj, setIsURICheckerModalOpen, history);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.theme]);

  if (state.connectToWeaviateURI !== "" || (hashObj && hashObj.weaviate_uri)) {
    return (
      <ModuleContent
        isURICheckerModalOpen={isURICheckerModalOpen}
        setIsURICheckerModalOpen={setIsURICheckerModalOpen}
      />
    );
  } else {
    return <WeaviateErrorPage />;
  }
};

export default Module;
